export type { FormStepTitleContent, FormStepTitleProps } from './types';

export { default as FormStepTitle } from './FormStepTitle';
